import { render } from "./SubscriptionGuide.vue?vue&type=template&id=8b3c6844&scoped=true"
import script from "./SubscriptionGuide.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionGuide.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionGuide.vue?vue&type=style&index=0&id=8b3c6844&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b3c6844"],['__file',"src/views/exhibitionManage/components/registrationSubscription/SubscriptionGuide.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8b3c6844"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8b3c6844', __exports__)) {
    console.log('reload')
    api.reload('8b3c6844', __exports__)
  }
  
  module.hot.accept("./SubscriptionGuide.vue?vue&type=template&id=8b3c6844&scoped=true", () => {
    console.log('re-render')
    api.rerender('8b3c6844', render)
  })

}


export default __exports__